import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, AlarmClockOff } from "lucide-react";
import { api } from "@/lib/api";
import { formatIsoDay, formatMoney, formatTRY } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

function Card({ title, icon: I, d, tone, testid, onOpen }) {
  return (
    <div className={`panel p-3 ${d.count ? tone : ""}`} data-testid={testid}>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 flex items-center gap-1"><I className="h-3.5 w-3.5" />{title}</div>
      <div className="mt-1 font-mono text-lg font-semibold" data-testid={`${testid}-count`}>{d.count} söz · {formatTRY(d.amount)}</div>
      {d.items.slice(0, 4).map((p) => <button key={p.id} className="block text-[12px] text-left hover:text-blue-700 truncate w-full" onClick={() => onOpen(p)} data-testid={`${testid}-${p.promise_no}`}>
        {p.customer_title} · {formatIsoDay(p.promise_date)} · kalan {formatMoney(p.remaining, p.currency)}</button>)}
    </div>
  );
}

export default function PromiseCards() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { if (can("tahsilatlar")) api.get("/odeme-sozleri/dashboard").then(({ data }) => setD(data)).catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const open = (p) => navigate(`/odeme-sozleri?id=${p.id}`);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3" data-testid="promise-cards">
      <Card title="Bugün Vadesi Gelen Ödeme Sözleri" icon={CalendarClock} d={d.due_today} tone="border-amber-300 bg-amber-50/40" testid="card-promises-today" onOpen={open} />
      <Card title="Geciken Ödeme Sözleri" icon={AlarmClockOff} d={d.overdue} tone="border-rose-300 bg-rose-50/40" testid="card-promises-overdue" onOpen={open} />
    </div>
  );
}
